module.exports = __webpack_public_path__ + "img/Background.19694609.jpg";